import { render, staticRenderFns } from "./PhPaperPlaneTilt.vue?vue&type=template&id=dc23baec"
import script from "./PhPaperPlaneTilt.vue?vue&type=script&lang=js"
export * from "./PhPaperPlaneTilt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports